import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

import { DashboardItemComponent } from './dashboard-item/dashboard-item.component';
import { DashboardItemListComponent } from './dashboard-item-list/dashboard-item-list.component';
import { DashboardHighlightsBlockComponent } from './dashboard-highlights-block/dashboard-highlights-block.component';
import { ContentHighlightBlockComponent } from './content-highlight-block/content-highlight-block.component';
import { PromotionBlockComponent } from './promotion-block/promotion-block.component';
import { SharedLibraryModule, ContentCardModule, ChaptersWidgetsModule } from 'library-explorer';
import { CarouselComponent } from './carousel/carousel.component';
import { NgScrollReachDrop } from 'ngx-scrollbar/reached-event';


@NgModule({
  declarations: [
    CarouselComponent,
    DashboardItemComponent,
    DashboardItemListComponent,
    DashboardHighlightsBlockComponent,
    ContentHighlightBlockComponent,
    PromotionBlockComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedLibraryModule,
    ContentCardModule,
    ChaptersWidgetsModule,
    NgScrollReachDrop
  ],
  exports: [
    CarouselComponent,
    DashboardItemComponent,
    DashboardItemListComponent,
    DashboardHighlightsBlockComponent,
    ContentHighlightBlockComponent,
    PromotionBlockComponent
  ]
})
export class DashboardModule { }
